import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { IContactInfoUpdateCreate, IContactInfo } from './interfaces';

const basePath = '/contactInfo';

export const getAll = <T>(orgId: number): AxiosPromise<IApiResponse<Array<IContactInfo>>> => vaultApi.getInstance().get(`${basePath}?orgId=${orgId}`);

export const getById = <T>(id: string): AxiosPromise<IApiResponse<IContactInfo>> => vaultApi.getInstance().get(`${basePath}/${id}`);

export const create = <T>(params: IContactInfoUpdateCreate): AxiosPromise<any> => vaultApi.getInstance().post(`${basePath}`, params);

export const update = <T>(id: string, params: IContactInfoUpdateCreate): AxiosPromise<any> => vaultApi.getInstance().put(`${basePath}/${id}`, params);

export const _delete = <T>(id: string): AxiosPromise<any> => vaultApi.getInstance().delete(`${basePath}/${id}`);

export const getByUserId = <T>(userId: number): AxiosPromise<IApiResponse<IContactInfo>> => vaultApi.getInstance().get(`${basePath}/getByUserId/${userId}`);
